
import styled from "styled-components"

const CustomerReview = ({author, description, media}) => {
	return (
		<Wrapper>
			<h2>”{description}”</h2>
			<Customer>
				<Logo>
					<img src={media.url} alt="logo"/>
				</Logo>
				<Author>{author}</Author>
			</Customer>
		</Wrapper>
	)
}

export default CustomerReview

const Wrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    gap: 60px;
`

const Customer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;

    @media (min-width: 600px) {
        flex-direction: row-reverse;
        align-items: center;
        justify-content: space-between;
    }
`

const Logo = styled.div`
    img {
        max-height: 5.55rem;
        max-width: 10.88rem;
        display: block;

        @media (max-width: 800px) {
            max-height: 3.1rem;
            max-width: 9.72rem;
        }
    }
`

const Author = styled.h4`
    word-break: break-word;
`
